import { useCallback, useEffect } from 'react';
import { getPreferredAudioOutputId } from '@streem/toolbox';
import { audio } from '../media';
import { logger } from '../util/logger';
const LOCAL_STORAGE_RESERVATION_PLAY_BUCKET = 'LS_RESERVATION_PLAY_BUCKET';
export function useReservationAudio() {
    const timeout = (delay) => {
        return new Promise(res => setTimeout(res, delay));
    };
    const repeatChime = useCallback(async (reservationId, times, delay, fnToRepeat) => {
        let remainingTimes = times;
        while (remainingTimes > 0 && getReservationPlayBucket()[reservationId]) {
            await fnToRepeat();
            const timesPlayed = times - remainingTimes + 1;
            logger.info(`Reservation chime has been played ${timesPlayed} time(s)`);
            await timeout(delay);
            remainingTimes--;
        }
    }, []);
    const getReservationPlayBucket = () => JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET) || '{}');
    const clearReservationPlayBucket = () => window.localStorage.removeItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET);
    const setRoomIdPlayingStatus = useCallback((reservationId, isPlaying = false) => {
        const reservationPlayBucket = getReservationPlayBucket();
        reservationPlayBucket[reservationId] = isPlaying;
        window.localStorage.setItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET, JSON.stringify(reservationPlayBucket));
    }, []);
    const playReservationAudio = useCallback(async (reservationId, times = 1, delay = 5000) => {
        if (!reservationId)
            return;
        setRoomIdPlayingStatus(reservationId, true);
        await repeatChime(reservationId, times, delay, audio.playReservationAudio);
    }, [repeatChime, setRoomIdPlayingStatus]);
    const pauseReservationAudio = useCallback(() => {
        // Don't need to log or clear bucket for non reservation workflows
        const reservationBucket = getReservationPlayBucket();
        if (Object.keys(reservationBucket).length === 0)
            return;
        // Cleaning the reference, since there can only be one reservation per expert, otherwise, only the reservation reference must be cleaned.
        clearReservationPlayBucket();
    }, []);
    const usePlayReservation = (reservationSid) => {
        useEffect(() => {
            const playReservationAudioAsync = async () => {
                try {
                    logger.info(`Attempting to play reservation ringtone for reservationSid=${reservationSid} through preferredAudioOutputId=${getPreferredAudioOutputId()}`);
                    await playReservationAudio(reservationSid, 4, 5000);
                }
                catch (error) {
                    logger.warn(`Failed to play Reservation ringtone for reservationSid=${reservationSid} through preferredAudioOutputId=${getPreferredAudioOutputId()} ${error}`);
                }
            };
            playReservationAudioAsync();
            return pauseReservationAudio;
        }, [reservationSid]);
    };
    // restrict this to reservation audio, because we don't want users of the standard ringtone to remove the event listener
    return {
        playReservationAudio,
        pauseReservationAudio,
        usePlayReservation,
    };
}
//# sourceMappingURL=use_reservation_audio.js.map